import _ from "lodash";

require('../../bootstrap');

import Vue          from 'vue';
import ComponentSet from "../../ComponentSet";
import utils        from "../../Utils";
import Constants    from "../../Constants";

// --------------------------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: ComponentSet,
    mixins: [utils],
    data: { 
        
    },
    created() {
        // 使用 Utils 的 method 設定
        //defaultOnCreated(this);
    },
    beforeDestroy() {

    },
    mounted() {
        // 取回該頁面需要用到的資料
        //this.retrieveSiteContentData();
    },
    methods: {        
        
    }, // end of methods
    computed: {
        serverRoot() {
            return Constants.serverRoot
        },
    }, // end of computed
}).$mount('#app');